import { useState, useEffect, useRef } from "react";
import {
  setAutoZeroRunManuallyBtnStatus,
  setQal3RunManuallyBtnStatus,
} from "../ducks/settingsUIDuck";
import { setCommandButtonDisabled } from "../ducks/uiDuck";

const useRoutineStartStopButtonWithCounter = (systemId, dispatch, sendCommand, commandName) => {
  const [counter, setCounter] = useState(0);
  const intervalRef = useRef(null);

  const unlockDisabledButtons = () => {
    console.log("UI BUTTONS UNLOCKED");
    dispatch(
      setAutoZeroRunManuallyBtnStatus({
        data: { isDisabled: false },
        systemId,
      })
    );
    dispatch(
      setQal3RunManuallyBtnStatus({
        data: { isDisabled: false },
        systemId,
      })
    );
    dispatch(
      setCommandButtonDisabled({
        data: {
          isServiceModeBtnDisabled: false,
          commandType: "serviceMode",
        },
        systemId,
      })
    );
    dispatch(
      setCommandButtonDisabled({
        data: {
          isAutoOrManualBtnDisabled: false,
          commandType: "AutoOrManual",
        },
        systemId,
      })
    );
  };

  const resetCounter = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      setCounter(0);
      intervalRef.current = null;
    }
  };

  const startCounter = () => {
    if (intervalRef.current) return;
    intervalRef.current = setInterval(() => {
      setCounter((prevCounter) => prevCounter + 1);
    }, 500);
  };

  const stopCounter = () => {
    if (intervalRef.current) {
      resetCounter();
      if (counter > 6) {
        unlockDisabledButtons();
      } else {
        dispatch(
          sendCommand({
            argsProps: {
              HwId: "EdgeDevice",
              Command: commandName, //AutoZero or Qal3
              Value: "Stop",
            },
            commandType: commandName,
            systemId,
          })
        );
      }
    }
  };

  useEffect(() => {
    return () => resetCounter();
  }, []);

  return { counter, startCounter, stopCounter, resetCounter };
};

export default useRoutineStartStopButtonWithCounter;
